// extracted by mini-css-extract-plugin
module.exports = {"root":"FiltersEquipment_root__1r54E","filters":"FiltersEquipment_filters__IUlkf","sum":"FiltersEquipment_sum__2xWAk","select":"FiltersEquipment_select__1IN0u"};